module.exports = __webpack_public_path__ + "static/media/sysadmin.ca2234ef.png";